/* GET CAMPAIGN NOTES*/
export const GET_CAMPAIGN_NOTES = "GET_CAMPAIGN_NOTES"
export const GET_CAMPAIGN_NOTES_SUCCESS = "GET_CAMPAIGN_NOTES_SUCCESS"
export const GET_CAMPAIGN_NOTES_ERROR = "GET_CAMPAIGN_NOTES_ERROR"

/*CREATE CAMPAIGN NOTES*/
export const CREATE_CAMPAIGN_NOTES = "CREATE_CAMPAIGN_NOTES"
export const CREATE_CAMPAIGN_NOTES_SUCCESS = "CREATE_CAMPAIGN_NOTES_SUCCESS"
export const CREATE_CAMPAIGN_NOTES_ERROR = "CREATE_CAMPAIGN_NOTES_ERROR"

/*UPDATE CAMPAIGN NOTES*/
export const UPDATE_CAMPAIGN_NOTES = "UPDATE_CAMPAIGN_NOTES"
export const UPDATE_CAMPAIGN_NOTES_SUCCESS = "UPDATE_CAMPAIGN_NOTES_SUCCESS"
export const UPDATE_CAMPAIGN_NOTES_ERROR = "UPDATE_CAMPAIGN_NOTES_ERROR"

/*DELETE CAMPAIGN */
export const DELETE_CAMPAIGN_NOTES = "DELETE_CAMPAIGN_NOTES"
export const DELETE_CAMPAIGN_NOTES_SUCCESS = "DELETE_CAMPAIGN_NOTES_SUCCESS"
export const DELETE_CAMPAIGN_NOTES_ERROR = "DELETE_CAMPAIGN_NOTES_ERROR"